import React, { useState, useEffect } from "react";
import { ApiService } from "../services";
import GEditable from "../gComponents/gEditable";
import { useSnackbar } from "react-simple-snackbar";
import GSwitch from "../gComponents/gSwitch";
import { DIV } from "../gComponents/gWalletStyles";
import { Info } from "@material-ui/icons";
import TooltipComponent from "../gComponents/gTooltip";
import useSettings from "../useSettings";

export default function WalletSettings(props) {
  const settings = useSettings();
  const [openSnackbar] = useSnackbar();
  const [walletData, setWalletsData] = useState({
    earn_order_max_coin_limits: {},
    earn_task_max_coin_limits: {},
    invite_text: {},
    order_cashback: {},
    order_complete_points_percentage: {},
    point_value: {},
    referral_rule: {},
    sender_referral_points: {},
    spend_order_points_amount_percentage: {},
    spend_task_points_amount_percentage: {},
    task_cashback: {},
    task_complete_points_percentage: {},
    user_referral_points: {},
    wallet_agent: {},
    wallet_refund: {},
    wallet_store: {},
    withdraw_agent: {},
    withdraw_store: {},
  });

  useEffect(() => {
    getWalletSettings();
  }, []);

  const getWalletSettings = () => {
    ApiService({ method: "GET", route: "setting/wallet" })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          setWalletsData(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function toggleValue(newValue, valueId, keyTitle) {
    console.log(newValue + "--" + valueId);
    updateField(newValue, valueId, keyTitle);
  }

  function updateField(newValue, selectedFieldId, keyTitle) {
    console.log(newValue);
    console.log(selectedFieldId);
    // return;
    var send_data = {
      key_value: newValue,
    };
    var hitUrl = "setting/" + selectedFieldId;
    ApiService({ method: "PUT", route: hitUrl, body: send_data })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          if (keyTitle) {
            walletData[keyTitle].key_value = newValue;
            setWalletsData(walletData);
          }
        } else {
          getWalletSettings();
        }

        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // We can use the `useParams` hook here to access
  // the dynamic pieces of the URL.

  return (
    <div className="rightInnerView">
      <h2>Wallet Settings</h2>

      <div className="listPaper">
        <div>
          <h4>Referral Points</h4>
          <DIV>
            <h4>Friend Referral</h4>
            <div className="inputStyle">
              <GEditable
                type="number"
                editable={false}
                id={walletData.sender_referral_points.id}
                defaultValue={walletData.sender_referral_points.key_value}
                onSubmit={(newVal, id) =>
                  updateField(newVal, id, "sender_referral_points")
                }
                style={{ margin: "0px", width: "calc(100% - 60px)" }}
                inputStyle={{
                  minWidth: "70px",
                  maxWidth: "80px",
                  width: "45%",
                  float: "right",
                }}
              />
              <span>Points</span>
            </div>
          </DIV>
          <DIV>
            <h4>New User</h4>
            <div className="inputStyle">
              <GEditable
                type="number"
                editable={false}
                id={walletData.user_referral_points.id}
                defaultValue={walletData.user_referral_points.key_value}
                onSubmit={(newVal, id) =>
                  updateField(newVal, id, "user_referral_points")
                }
                style={{ margin: "0px", width: "calc(100% - 60px)" }}
                inputStyle={{
                  minWidth: "70px",
                  maxWidth: "80px",
                  width: "45%",
                  float: "right",
                }}
              />
              <span>Points</span>
            </div>
          </DIV>
          <DIV>
            <h4>
              Restrict on Order Completion
              <TooltipComponent
                title="
If turned on, then both the users (Friend Referral & New User) will get points only after the New User will complete its 1st order successfully.
"
                position="bottom"
                id={walletData.referral_rule.id}
              >
                <Info fontSize="small" />
              </TooltipComponent>
            </h4>
            <div style={{ width: "calc(100% - 320px)" }}>
              <GSwitch
                id={walletData.referral_rule.id}
                uId={walletData.referral_rule.id}
                currentValue={walletData.referral_rule.key_value}
                style={{ margin: "10px 0", float: "right" }}
                onSwitchChange={(newVal, id) =>
                  toggleValue(newVal, id, "referral_rule")
                }
              />
            </div>
          </DIV>

          <hr />
          <h4>
            Cashback Points{" "}
            <GSwitch
              id={walletData.order_cashback.id}
              uId={walletData.order_cashback.id}
              currentValue={walletData.order_cashback.key_value}
              style={{
                display: "inline-block",
                paddingLeft: "20px",
                verticalAlign: "middle",
              }}
              onSwitchChange={(newVal, id) =>
                toggleValue(newVal, id, "order_cashback")
              }
            />
          </h4>
          <DIV>
            <h4>Cashback per Order</h4>
            <div className="inputStyle">
              <GEditable
                type="number"
                editable={false}
                id={walletData.order_complete_points_percentage.id}
                defaultValue={
                  walletData.order_complete_points_percentage.key_value
                }
                onSubmit={(newVal, id) =>
                  updateField(newVal, id, "order_complete_points_percentage")
                }
                style={{ margin: "0px", width: "calc(100% - 100px)" }}
                inputStyle={{
                  minWidth: "70px",
                  maxWidth: "80px",
                  width: "45%",
                  float: "right",
                }}
              />
              <span style={{ width: "100px" }}>% of subtotal</span>
            </div>
          </DIV>
          <DIV>
            <h4>Maximum Points earned per Order</h4>
            <div className="inputStyle">
              <GEditable
                type="number"
                editable={false}
                id={walletData.earn_order_max_coin_limits.id}
                defaultValue={walletData.earn_order_max_coin_limits.key_value}
                onSubmit={(newVal, id) =>
                  updateField(newVal, id, "earn_order_max_coin_limits")
                }
                style={{ margin: "0px", width: "calc(100% - 60px)" }}
                inputStyle={{
                  minWidth: "70px",
                  maxWidth: "80px",
                  width: "45%",
                  float: "right",
                }}
              />
              <span>Points</span>
            </div>
          </DIV>

          <hr />
          <h4>Discount</h4>
          <DIV>
            <h4>Maximum discount</h4>
            <div className="inputStyle">
              <GEditable
                type="number"
                maxLength={3}
                editable={false}
                maxVal={100}
                id={walletData.spend_order_points_amount_percentage?.id}
                defaultValue={
                  walletData.spend_order_points_amount_percentage?.key_value
                }
                onSubmit={(newVal, id) =>
                  updateField(
                    newVal,
                    id,
                    "spend_order_points_amount_percentage"
                  )
                }
                style={{ margin: "0px", width: "calc(100% - 100px)" }}
                inputStyle={{
                  minWidth: "75px",
                  maxWidth: "100px",
                  width: "45%",
                  float: "right",
                }}
              />
              <span style={{ width: "100px" }}>% of subtotal</span>
            </div>
          </DIV>
          <DIV>
            <h4>Points Conversion Rate</h4>
            <div className="inputStyle">
              <GEditable
                type="number"
                editable={false}
                id={walletData.point_value?.id}
                defaultValue={walletData.point_value?.key_value}
                onSubmit={(newVal, id) =>
                  updateField(newVal, id, "point_value")
                }
                style={{ margin: "0px", width: "calc(100% - 75px)" }}
                inputStyle={{
                  minWidth: "75px",
                  maxWidth: "100px",
                  width: "45%",
                  float: "right",
                }}
              />
              <span style={{ width: "75px" }}>
                Points / {settings?.currency_symbol}
              </span>
            </div>
          </DIV>

          <hr />
          <h4>
            Driver Wallet
            <GSwitch
              id={walletData.wallet_agent.id}
              uId={walletData.wallet_agent.id}
              currentValue={walletData.wallet_agent.key_value}
              style={{
                display: "inline-block",
                paddingLeft: "20px",
                verticalAlign: "middle",
              }}
              onSwitchChange={(newVal, id) =>
                updateField(newVal, id, "wallet_agent")
              }
            />
          </h4>

          {walletData.wallet_agent.key_value === "1" ? (
            <DIV>
              <h4>Allow Withdraw</h4>
              <div style={{ width: "calc(100% - 320px)" }}>
                <GSwitch
                  id={walletData.withdraw_agent.id}
                  uId={walletData.withdraw_agent.id}
                  currentValue={walletData.withdraw_agent.key_value}
                  style={{ margin: "10px 0", float: "right" }}
                  onSwitchChange={(newVal, id) =>
                    updateField(newVal, id, "withdraw_agent")
                  }
                />
              </div>
            </DIV>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
